import { makeAutoObservable } from 'mobx'

export class AudioVolumeLevelStore {
  microphoneAudioContext: AudioContext | null = null
  microphoneAudioAnalyzer: AnalyserNode | null = null
  microphoneAudioStreamSource: MediaStreamAudioSourceNode | null = null
  microphoneAudioArray: Uint8Array<ArrayBuffer> = new Uint8Array(1)
  microphoneAudioFrame = 0
  microphoneAudioLevel = 0
  readonly microphoneAudioLevelItems: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]

  constructor() {
    makeAutoObservable(this)
  }

  init = (stream: MediaStream) => {
    this.handleClear()

    this.microphoneAudioContext = new AudioContext()
    this.microphoneAudioAnalyzer = this.microphoneAudioContext.createAnalyser()
    this.microphoneAudioAnalyzer.fftSize = 1024
    this.microphoneAudioAnalyzer.smoothingTimeConstant = 0.3
    this.microphoneAudioArray = new Uint8Array(this.microphoneAudioAnalyzer.frequencyBinCount)
    this.microphoneAudioStreamSource = this.microphoneAudioContext.createMediaStreamSource(stream)
    this.microphoneAudioStreamSource.connect(this.microphoneAudioAnalyzer)
    this.handleLoop()
  }

  handleLoop = () => {
    if (!this.microphoneAudioAnalyzer) return
    if (!this.microphoneAudioContext) return

    const sampleRate = this.microphoneAudioContext.sampleRate
    const binCount = this.microphoneAudioAnalyzer.frequencyBinCount
    const hzPerBin = sampleRate / (binCount * 2)

    const minBin = Math.floor(85 / hzPerBin)
    const maxBin = Math.ceil(3000 / hzPerBin)

    this.microphoneAudioAnalyzer.getByteFrequencyData(this.microphoneAudioArray)

    const bins = Array.from(this.microphoneAudioArray.slice(minBin, maxBin + 1))
    bins.sort((a, b) => b - a)
    const top = bins.slice(0, Math.ceil(bins.length * 0.1))
    const THRESHOLD = 100
    const avg = top.reduce((s, v) => s + v, 0) / top.length
    this.microphoneAudioLevel = avg < THRESHOLD ? 0 : Math.ceil((avg * 100) / 255)

    this.microphoneAudioFrame = window.requestAnimationFrame(this.handleLoop)
  }

  handleClear = () => {
    window.cancelAnimationFrame(this.microphoneAudioFrame)
    this.microphoneAudioStreamSource?.disconnect()
    this.microphoneAudioContext?.close()

    this.microphoneAudioStreamSource = null
    this.microphoneAudioAnalyzer = null
    this.microphoneAudioContext = null
  }
}
